class ImmunitySerology {
    public HasRubella: boolean;
    public ParvoB19: string;
    public ChickenPox: string;
    public Toxo: string;
    public Value0: string;
    public Value1: string;

    constructor(fields?: Partial<ImmunitySerology>) {
        Object.assign(this, fields);
    }
}

export { ImmunitySerology };
